function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "kic-path-1",
  points: "0.0004 0.444 25.974 0.444 25.974 14 0.0004 14"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.5556,7.502 C10.5726,7.516 10.5886,7.528 10.6046,7.54 L10.5996,7.55 C10.6076,7.555 10.6526,7.581 10.7646,7.648 C10.7836,7.659 10.7996,7.669 10.8156,7.679 C10.8216,7.682 10.8266,7.686 10.8336,7.689 C11.0376,7.811 11.4016,8.027 12.0156,8.394 C13.0706,9.022 13.0556,9.854 12.9146,10.361 L14.3696,10.361 C14.5156,9.372 14.2876,8.066 12.7546,7.152 L11.6146,6.473 C11.5986,6.463 11.5816,6.453 11.5646,6.443 C11.3716,6.315 9.3966,4.954 10.2516,3.423 L11.6416,1.093 C11.8456,0.75 11.7336,0.307 11.3916,0.103 C11.0486,-0.102 10.6056,0.01 10.4016,0.353 L9.0006,2.701 C7.8406,4.777 9.3966,6.655 10.5556,7.502",
  fill: "#FEFEFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.4775,15.5196 C4.6515,15.5196 3.9805,16.1916 3.9805,17.0166 C3.9805,17.8426 4.6515,18.5146 5.4775,18.5146 C6.3035,18.5146 6.9745,17.8426 6.9745,17.0166 C6.9745,16.1916 6.3035,15.5196 5.4775,15.5196",
  fill: "#FEFEFE"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 11.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "kic-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#kic-path-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M23.5234,6.71 C23.1404,7.093 22.5194,7.093 22.1364,6.71 C21.7534,6.327 21.7534,5.706 22.1364,5.323 C22.5194,4.94 23.1404,4.94 23.5234,5.323 C23.9064,5.706 23.9064,6.327 23.5234,6.71 M21.3394,4.526 C20.9574,4.909 20.3354,4.909 19.9534,4.527 C19.5704,4.144 19.5704,3.523 19.9534,3.141 C20.3354,2.757 20.9574,2.757 21.3394,3.141 C21.7224,3.523 21.7224,4.144 21.3394,4.526 M21.3394,8.894 C20.9574,9.276 20.3354,9.276 19.9534,8.894 C19.5704,8.511 19.5704,7.89 19.9534,7.507 C20.3354,7.124 20.9574,7.124 21.3394,7.507 C21.7224,7.891 21.7224,8.511 21.3394,8.894 M19.1564,6.71 C18.7734,7.093 18.1524,7.093 17.7694,6.71 C17.3864,6.327 17.3864,5.706 17.7694,5.323 C18.1524,4.94 18.7734,4.94 19.1564,5.323 C19.5394,5.706 19.5394,6.327 19.1564,6.71 M5.4774,8.887 C3.8954,8.887 2.6074,7.6 2.6074,6.017 C2.6074,4.435 3.8954,3.147 5.4774,3.147 C7.0594,3.147 8.3474,4.435 8.3474,6.017 C8.3474,7.6 7.0594,8.887 5.4774,8.887 M20.1864,0.444 L20.1624,0.444 L5.8124,0.444 L5.7874,0.444 C2.5964,0.444 0.0004,3.133 0.0004,6.438 C0.0004,8.774 0.0004,14 3.7734,14 C5.8284,14 9.5394,11.441 10.7894,8.424 L15.1844,8.424 C16.4354,11.441 20.1454,14 22.2004,14 C25.9744,14 25.9744,8.774 25.9744,6.438 C25.9744,3.133 23.3774,0.444 20.1864,0.444",
  fill: "#FEFEFE",
  mask: "url(#kic-mask-2)"
}))));

var SvgKickertableFifa = function SvgKickertableFifa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "28px",
    viewBox: "0 0 45 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKickertableFifa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kickertable-fifa.b6bd0145.svg";
export { ForwardRef as ReactComponent };